const $$splitComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_authenticated/_app/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
/**
 * Root home (`/`), inside the authenticated shell so it shows the primary
 * sidebar only. An empty placeholder for now — the app has no default feature
 * section, and the `_authenticated` layout's guard already redirects signed-out
 * visitors.
 */
export const Route = createFileRoute('/_authenticated/_app/')({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});